import validate from 'uuid-validate';

export const validUuid = (uuid: string | string[] | null): boolean => {
    return validate(uuid);
};

export const processSessionUuid = (sessionUuid: string) => {
    if (sessionUuid?.includes('&_branch_match_id')) {
        sessionUuid = sessionUuid.split('&_')[0];
    }
    if (sessionUuid?.includes('session')) {
        sessionUuid = sessionUuid.split('session=')[1];
    }

    return sessionUuid;
};
